import { Heading } from '@chakra-ui/react'
import React from 'react'
import Header from './Header'


const About = () => {
  return (
    <>
    <div id="about" className="about section" style={{width:"80%",margin:"auto",color:"white",padding:"10px 0"}}  >
    <h1 style={{fontSize:"24px", fontWeight:"bold"}}>About me</h1>
    <div style={{display:"flex", justifyContent:"space-between"}}>
       {/* <img src="https://akashsaha747.github.io/gif/Prashant.gif" alt="gif" width={'200px'}/> */}
      <div id="user-detail-intro" className='about section' style={{color:"white"}}> 
      👋 I'm Shailesh Kumar Budakoti
a dynamic and self-motivated Full Stack Web Developer with expertise in Tech HTML, CSS, JavaScript Java, DSA, React, Redux, Node.js, Express, and MongoDB.</div></div>
    </div>
    </>
  )
}

export default About